var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lesson-preparation"},[_c('h3',{staticClass:"title"},[_vm._v("Bijlagen")]),_vm._v(" "),_c('ul',{staticClass:"attachments-list"},_vm._l((_vm.filesIn),function(file){return _c('li',{key:file.id,staticClass:"attachment-item"},[_c('a',{staticClass:"lesson-attachment",attrs:{"href":file.path,"target":"_blank"}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }